export default "__VITE_ASSET__CmfkUgMb__"